<template>
  <div class="mt-10 flex flex-wrap" v-if="hasMoreThanOnePage">
    <template v-for="(link, key) in links">
      <div v-if="link.url === null" :key="key" class="mr-1 mb-1 px-4 py-3 text-base border border-gray-300 rounded text-gray-400 cursor-default" :class="{ 'ml-auto': link.label === 'Next' }" v-html="link.label">
      </div>
      <inertia-link :preserve-scroll="true" v-else :key="key" class="mr-1 mb-1 px-4 py-3 text-base border border-gray-300 rounded bg-white hover:bg-coral-400 hover:text-white focus:outline-none outline-none"
                    :class="{ 'bg-coral-400 text-white': link.active, 'ml-auto': link.label === 'Next' }" :href="link.url" v-html="link.label">
      </inertia-link>
    </template>
  </div>
</template>

<script>

  export default {
    props: {
      links: Array,
    },

    computed: {
      hasMoreThanOnePage() {
        return this.links.length > 3;
      }
    }
  }
</script>
